import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.search";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
import slideUp from '@/components/slideUp.vue';
import yLayer from '@/components/layer.vue';
import { getUrlToken, toQueryString, toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import { isYKZApp } from '@ykz/ykz-util/platform';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'welfare_task_component',
  data: function data() {
    return {
      weChatId: getUrlToken('weChatId') || '',
      fromWeChatId: getUrlToken('fromWeChatId') || '',
      simData: getUrlParams('simData'),
      isApp: isYKZApp(),
      //是否app
      propData: [],
      //父组件传递的数据
      dataList: [],
      //列表数据
      scrollTop: null,
      dialogShowed: false,
      // 是否显示对话框
      isSlideUp: false,
      // 是否上拉

      welfareSuccessData: {},
      //展示弹窗的数据
      isShowWelfarePop: false //限时福利弹框
    };
  },

  filters: {},
  props: ['data'],
  components: {
    slideUp: slideUp,
    yLayer: yLayer
  },
  watch: {
    data: {
      immediate: false,
      handler: function handler(newVal) {
        this.propData = newVal;
      }
    },
    isSlideUp: function isSlideUp(newVal) {
      this.setOverflow(newVal);
      this.handleVisible(newVal);
    },
    isShowWelfarePop: function isShowWelfarePop(newVal) {
      this.setOverflow(newVal);
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.welfareTaskComponent = this;
    console.log('ycf组件初始化：welfareTaskComponent');
  },
  methods: {
    // ------------------------------------------------------弹窗Start----------------------------------------------------->
    diaLogStatus: function diaLogStatus(flag) {
      this.isShowWelfarePop = flag;
    },
    // 显示签到成功弹窗
    showWelfarePop: function showWelfarePop() {
      this.welfareSuccessData = {
        isShowDialog: true,
        animateType: 2,
        extraClass: 'success-panel'
      };
    },
    closeWelfarePop: function closeWelfarePop() {
      this.welfareSuccessData = {
        isCloseDialog: true
      };
    },
    showWelfareList: function showWelfareList() {
      var _this = this;
      this.closeWelfarePop();
      setTimeout(function () {
        _this.openWelfareList();
      }, 200);
    },
    // ------------------------------------------------------弹窗相关End----------------------------------------------------->
    //------------------------------------------------------上拉列表相关Start----------------------------------------------->
    goMyTask: function goMyTask() {
      window.location.href = "/front/promoter/myTask".concat(window.location.search, "&tabIndex=1");
    },
    //处理数据
    handlerData: function handlerData(res) {
      var _this2 = this;
      // let { timeStamp, content } = res;
      var timeStamp = parseInt(new Date().getTime() / 1000);
      if (!res) return;
      res.forEach(function (v) {
        if (v.type == 1 || v.type == 4) {
          //排行榜任务和其他任务不一样
          v.timeDesc = _this2.handlerTimeDescSpe(timeStamp, v);
          v.btnTxt = _this2.handlerBtnTxtSpe(v);
        } else {
          v.timeDesc = _this2.handlerTimeDesc(timeStamp, v);
          v.btnTxt = _this2.handlerBtnTxt(v);
        }
        v.describe = _this2.addStyleForString(v.label, v.prizeValue);
      });
      this.$set(this, 'dataList', res);
    },
    //匹配字符串增加字体样式
    addStyleForString: function addStyleForString(string, targetString) {
      return string.replace(new RegExp(targetString, 'gm'), '<span style="color: #FF7124;">' + targetString + '</span>');
    },
    handlerTimeDesc: function handlerTimeDesc(timeStamp, task) {
      var beginTime = task.beginTime,
        endTime = task.endTime,
        totalLevel = task.totalLevel,
        completionLevel = task.completionLevel,
        type = task.type,
        prefix = '',
        isEnd = false,
        suffix = {
          0: '开始，敬请关注',
          1: '后结束',
          2: '恭喜你已完成任务，快去领取奖励吧~',
          3: '活动已结束！'
        },
        id = 0;

      // 活动开始
      if (timeStamp < beginTime) {
        var date = new Date(Number(beginTime + '000'));
        prefix = "".concat(date.getFullYear(), "\u5E74").concat(date.getMonth() + 1, "\u6708").concat(date.getDate(), "\u65E5").concat(date.getHours(), "\u65F6");
      }

      // 活动进行中
      if (beginTime <= timeStamp && timeStamp < endTime) {
        var time = endTime - timeStamp,
          day = ~~(time / (3600 * 24)),
          hour = ~~(time % (3600 * 24) / 3600),
          minute = ~~(time % (3600 * 24) % 3600 / 60),
          second = ~~(time % (3600 * 24) % 3600 % 60);
        prefix = "".concat(day ? "".concat(day, "\u5929") : '').concat(hour ? "".concat(hour, "\u65F6") : '').concat(minute ? "".concat(minute, "\u5206") : '').concat(second, "\u79D2");
        id = 1;
      }

      //停留页面恰好任务时间过期处理
      if (timeStamp >= endTime) {
        prefix = '';
        isEnd = true;
        id = 3;
      }

      // 奖励全部领取
      if (totalLevel == completionLevel && type != 3) {
        prefix = '';
        id = 2;
      }
      return {
        isEnd: isEnd,
        describe: prefix + suffix[id]
      };
    },
    handlerBtnTxt: function handlerBtnTxt(task) {
      var totalLevel = task.totalLevel,
        completionLevel = task.completionLevel,
        hasRecTask = task.hasRecTask,
        type = task.type,
        canRecTask = task.canRecTask,
        timeDesc = task.timeDesc,
        txt = {
          0: '领取任务',
          1: '继续完成',
          2: '全部完成',
          3: '已领完',
          4: '已过期'
        },
        id = 0;
      if (timeDesc.isEnd) {
        id = 4;
        if (type == 2 && hasRecTask && totalLevel == completionLevel) {
          id = 2;
        }
      } else {
        if (!hasRecTask) {
          id = 0;
          if (!canRecTask) {
            id = 3;
          }
        } else {
          if (totalLevel > completionLevel) {
            id = 1;
          }
          if (totalLevel == completionLevel) {
            id = 2;
          }
          if (type == 3) {
            id = 1;
          }
        }
      }
      return txt[id];
    },
    handlerTimeDescSpe: function handlerTimeDescSpe(timeStamp, task) {
      var beginTime = task.beginTime,
        endTime = task.endTime,
        prefix = '',
        isEnd = false,
        suffix = {
          0: '开始，敬请关注',
          1: '后结束',
          2: '活动已结束！'
        },
        id = 0;

      // 活动开始
      if (timeStamp < beginTime) {
        var date = new Date(Number(beginTime + '000'));
        prefix = "".concat(date.getFullYear(), "\u5E74").concat(date.getMonth() + 1, "\u6708").concat(date.getDate(), "\u65E5").concat(date.getHours(), "\u65F6");
      }

      // 活动进行中
      if (beginTime <= timeStamp && timeStamp < endTime) {
        var time = endTime - timeStamp,
          day = ~~(time / (3600 * 24)),
          hour = ~~(time % (3600 * 24) / 3600),
          minute = ~~(time % (3600 * 24) % 3600 / 60),
          second = ~~(time % (3600 * 24) % 3600 % 60);
        prefix = "".concat(day ? "".concat(day, "\u5929") : '').concat(hour ? "".concat(hour, "\u65F6") : '').concat(minute ? "".concat(minute, "\u5206") : '').concat(second, "\u79D2");
        id = 1;
      }

      //停留页面恰好任务时间过期处理
      if (timeStamp >= endTime) {
        prefix = '';
        isEnd = true;
        id = 2;
      }
      return {
        isEnd: isEnd,
        describe: prefix + suffix[id]
      };
    },
    handlerBtnTxtSpe: function handlerBtnTxtSpe(task) {
      var hasRecTask = task.hasRecTask,
        timeDesc = task.timeDesc,
        txt = {
          0: '领取任务',
          1: '继续完成',
          2: '已过期'
        },
        id = 0;
      if (timeDesc.isEnd) {
        id = 2;
      } else {
        if (!hasRecTask) {
          id = 0;
        } else {
          id = 1;
        }
      }
      return txt[id];
    },
    goTaskDetails: function goTaskDetails(item) {
      if (!this.isApp) {
        this.dialogShowed = true;
        return;
      }
      var activityId,
        status,
        urlObj = {};
      var type = item.type,
        taskId = item.taskId,
        weChatId = this.weChatId,
        fromWeChatId = this.fromWeChatId,
        simData = this.simData;
      if (type == 1 || type == 4) {
        status = 1;
        urlObj = {
          weChatId: weChatId,
          fromWeChatId: fromWeChatId
        };
      } else {
        status = item.status;
        urlObj = {
          weChatId: weChatId,
          fromWeChatId: fromWeChatId,
          taskId: taskId
        };
      }
      simData && (urlObj.simData = simData);
      if (status == 1) {
        if (type == 1) {
          urlObj.activityId = taskId;
          window.location.href = "/front/sales-rank/list?".concat(toQueryString(urlObj));
        } else if (type == 2) {
          // urlObj.city = encodeURIComponent(selectCity);
          window.location.href = "/front/promoter/taskDetails?".concat(toQueryString(urlObj));
        } else if (type == 3) {
          window.location.href = "/front/promoter/recruitTaskDetail?".concat(toQueryString(urlObj));
        } else if (type == 4) {
          window.location.href = "/front/promoter/saleAward?".concat(toQueryString(urlObj));
        }
      }
    },
    takeTask: function takeTask(item) {
      var _this3 = this;
      if (!this.isApp) {
        this.dialogShowed = true;
        return;
      }
      if (item.timeDesc.isEnd) {
        return;
      }
      var canRecTask = true,
        data = {};
      var hasRecTask = item.hasRecTask,
        type = item.type,
        taskId = item.taskId;
      if (type == 1) {
        data.taskId = taskId;
      } else if (type == 4) {
        data.activityId = taskId;
      } else {
        data.taskId = taskId;
        canRecTask = item.canRecTask;
      }
      if (!hasRecTask && canRecTask) {
        databus({
          type: 'get',
          data: data,
          url: "".concat(type == 4 ? '/api/outputOrder/receive' : '/api/ordertask/takeTask'),
          origin: type == 4 ? Origins.API_MARKETING : Origins.API_ACT,
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100 && item.type != 1 && item.type != 4) {
              window.sessionStorage.setItem('takeTaskData', JSON.stringify(res.content));
            } else if (item.type == 1 || item.type == 4) {
              toast('领取成功~');
            }
          },
          beforeSend: function beforeSend() {
            showLoading();
          },
          complete: function complete() {
            hideLoading();
            _this3.goTaskDetails(item);
          }
        });
      } else {
        this.goTaskDetails(item);
      }
    },
    openWelfareList: function openWelfareList() {
      var _this4 = this;
      this.handlerData(this.propData);
      this.$nextTick(function () {
        _this4.isSlideUp = true;
      });
    },
    closeWelfareList: function closeWelfareList() {
      this.isSlideUp = false;
    },
    //处理弹窗
    handleVisible: function handleVisible(flag) {
      if (window.location.hash.replace('#', '') != 'welfareList') {
        if (flag === true) {
          window.location.hash = 'welfareList';
        }
      } else {
        window.history.go(-1);
      }
    },
    //兼容ios系统overflow对z-index层级关系的影响
    setOverflow: function setOverflow(val) {
      if (val) {
        $('.scroll-area').css('overflow-y', 'hidden');
      } else {
        $('.scroll-area').css('overflow-y', '');
      }
    } //------------------------------------------------------上拉列表相关End----------------------------------------------->
  }
};